import React from 'react'

function Statistics() {
    return (<div>This is Statistics</div>)
}

export default Statistics;